import { baseUrl, singleOriginEnabled } from './constants';
import { handleBasename } from './handle-basename';

const apiUrlMappings: Record<string, string> = {
  localhost: 'http://localhost:1984',
  'dev.smith.langchain.com': 'https://dev.api.smith.langchain.com',
  'beta.smith.langchain.com': 'https://beta.api.smith.langchain.com',
  'smith.langchain.com': 'https://api.smith.langchain.com',
  'eu.smith.langchain.com': 'https://eu.api.smith.langchain.com',
};

export function getAPIUrl() {
  const originUrl = new URL(window.location.origin);

  if (singleOriginEnabled !== '0') {
    const path = handleBasename('/api/v1', baseUrl);
    return `${window.location.protocol}//${originUrl.host}${path}`;
  } else if (originUrl.hostname in apiUrlMappings) {
    return apiUrlMappings[originUrl.hostname];
  } else {
    const newUrl = originUrl.hostname.replace(/^www\./, 'api.');
    return `${window.location.protocol}//${newUrl}`;
  }
}

export function getAPIUrlVercel() {
  const apiUrl = getAPIUrl();
  let baseSchemaUrl = apiUrl;
  if (baseSchemaUrl.endsWith('langchain.vercel.app')) {
    baseSchemaUrl = 'https://dev.api.smith.langchain.com';
  }
  return baseSchemaUrl;
}
